import { render, staticRenderFns } from "./RepairRecord.vue?vue&type=template&id=6ac4eb5a&scoped=true&"
import script from "./RepairRecord.vue?vue&type=script&lang=ts&"
export * from "./RepairRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac4eb5a",
  null
  
)

export default component.exports